import { Form } from "antd";
import { Select, SelectOption } from "ui"
import { Product } from "../../../../interfaces/BackendModels";
import { useTranslations } from "../hooks/use-translations"

interface Props {
  products: Product[];
  disabled: boolean;
}

export default function ProductSelectField({ products, disabled }: Props) {
  const t = useTranslations()

  return (
    <>
      <Form.Item name="product_ids" label={t("coupons.form.product")}>
        <Select name="product_ids" mode="multiple" disabled={disabled} allowClear>
          {products?.map(p => (
            <SelectOption key={p.id} value={p.id}>{p.name}</SelectOption>
          ))}
        </Select>
      </Form.Item>
      <div className="description">
        {t("coupons.form.product.description")}
      </div>
    </>
  );
}